<script setup>
import ModalWrapper from '@/modals/ModalWrapper';

defineProps({
    title: {
        type: String,
        default: 'Alert',
    },
    prompt: {
        type: String,
        default: '',
    },
});

const emit = defineEmits(['close-modal']);

const closeModal = () => {
    emit('close-modal', true);
};
</script>

<template>
<ModalWrapper body-class="modal-default-content" :fixed-height="false">
    <template #header>
        {{ title }}
    </template>

    <template #subheader>
        {{ prompt }}
    </template>

    <template #footer>
        <StyledButton @click="closeModal">
            {{ $t('common.button.ok') }}
        </StyledButton>
    </template>
</ModalWrapper>
</template>
